import { render, staticRenderFns } from "./MainAppBar.vue?vue&type=template&id=2c965eb8&scoped=true&"
import script from "./MainAppBar.vue?vue&type=script&lang=js&"
export * from "./MainAppBar.vue?vue&type=script&lang=js&"
import style0 from "./MainAppBar.vue?vue&type=style&index=0&id=2c965eb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c965eb8",
  null
  
)

export default component.exports